import ArrowLeft from '@img/icons/arrow_left.svg';
import ArrowRight from '@img/icons/arrow_right.svg';
import ArrowRightHollow from '@img/icons/arrow-right-hollow.svg';
import Chevron from '@img/icons/chevron.svg';
import Close from '@img/icons/close.svg';
import ExpandHollow from '@img/icons/expand-hollow.svg';
import Instagram from '@img/icons/instagram.svg';
import LinkedIn from '@img/icons/linkedin-full.svg';
import PlayHollow from '@img/icons/play-hollow.svg';
import Tick from '@img/icons/tick.svg';
import Twitter from '@img/icons/twitter-full.svg';
import React from 'react';
export var SystemIcon;
(function (SystemIcon) {
    SystemIcon["ArrowLeft"] = "arrow-left";
    SystemIcon["ArrowRight"] = "arrow-right";
    SystemIcon["ArrowRightHollow"] = "arrow-right-hollow";
    SystemIcon["Chevron"] = "chevron";
    SystemIcon["Close"] = "close";
    SystemIcon["ExpandHollow"] = "expand-hollow";
    SystemIcon["Instagram"] = "instagram";
    SystemIcon["LinkedIn"] = "linked-in";
    SystemIcon["PlayHollow"] = "play-hollow";
    SystemIcon["Tick"] = "tick";
    SystemIcon["Twitter"] = "twitter";
})(SystemIcon || (SystemIcon = {}));
export function getSvgFromSystem(icons) {
    switch (icons) {
        case SystemIcon.ArrowLeft: {
            return React.createElement(ArrowLeft, null);
        }
        case SystemIcon.ArrowRight: {
            return React.createElement(ArrowRight, null);
        }
        case SystemIcon.ArrowRightHollow: {
            return React.createElement(ArrowRightHollow, null);
        }
        case SystemIcon.Chevron: {
            return React.createElement(Chevron, null);
        }
        case SystemIcon.Close: {
            return React.createElement(Close, null);
        }
        case SystemIcon.ExpandHollow: {
            return React.createElement(ExpandHollow, null);
        }
        case SystemIcon.Instagram: {
            return React.createElement(Instagram, null);
        }
        case SystemIcon.LinkedIn: {
            return React.createElement(LinkedIn, null);
        }
        case SystemIcon.PlayHollow: {
            return React.createElement(PlayHollow, null);
        }
        case SystemIcon.Tick: {
            return React.createElement(Tick, null);
        }
        case SystemIcon.Twitter: {
            return React.createElement(Twitter, null);
        }
        default: {
            return null;
        }
    }
}
